<script lang="js">
import routeEvents from '@/lib/route-events'
import Program from './Program'
import Post from './Post'
import Page from './Page'

export default {
  name: 'SinglePage',
  components: { Program, Post, Page },
  props: [ 'post', 'path' ],
  beforeRouteUpdate: routeEvents.toPath,
  render(h) {
    var post = this.post || this.$store.state.post
    console.log( 'post is', post )
    if ( !post ) {
      return h( 'page-not-found', {
        props: {
          path: this.path
        }
      })
    }
    if ( post.type === 'program' ) {
      return h( 'program', {
        props: {
          post: post,
          path: this.path
        }
      })
    }
    if ( post.type === 'post' ) {
      return h( 'post', {
        props: {
          post: post,
          path: this.path
        }
      })
    }
    return h( 'page', {
      props: {
        post: post,
        path: this.path
      }
    })
  }
}
</script>

<style lang="scss">
.single {

}
</style>
